import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{ value: string }>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RoutedTabContent = (props: Props) => {
  return null;
};
